/* eslint-disable */
import {
	BIAudioFrame,
	BITMAPINFOHEADER,
	BIVideoFrame,
	ReadInt32,
	ReadSubArray,
	ReadUInt16,
	ReadUInt32,
	ReadUInt32LE,
	ReadUInt64LE,
	WAVEFORMATEX,
} from 'ui3';

export function processStream(stream, reader, callFrameCallback, callStreamEnded, isPausedRef) {
	// Do NOT return before the first reader.read() or the fetch can be left in
	// a bad state! Except if reader is null of course.
	if (reader === null) {
		return;
	}

	let state = 0;
	let availableStreams = 0; // 1 for video, 2 for audio and video.
	let streamHeaderSize = 0;
	let blockType = -1;
	let baseVideoFrameTime = -1;
	let lastVideoFrameTime = -1;
	let currentVideoFrame = { pos: 0, time: 0, rawtime: 0, utc: 0, size: 0 };
	let currentAudioFrame = { size: 0 };
	let statusBlockSize = 0;
	let bitmapHeader = null;
	let audioHeader = null;

	let isPumpScheduled = false;

	function pump() {
		if (isPausedRef.current) {
			if (!isPumpScheduled) {
				isPumpScheduled = true;
				setTimeout(() => {
					isPumpScheduled = false;
					pump();
				}, 100); // Check again after 100ms
			}
			return;
		}

		reader
			.read()
			.then(function (result) {
				try {
					if (result.done) {
						return;
					}

					stream.Write(result.value);

					while (stream) {
						if (state == 0) {
							// Read Stream Header Start
							var buf = stream.Read(6);
							if (buf == null) {
								return pump();
							}

							// First 4 bytes are supposed to be ASCII "blue"
							if (buf[0] != 98 || buf[1] != 108 || buf[2] != 117 || buf[3] != 101) {
								return callStreamEnded(reader, 'stream did not start with "blue"');
							}

							availableStreams = buf[4];
							if (availableStreams != 1 && availableStreams != 2) {
								return callStreamEnded(
									reader,
									'availableStreams (' +
										availableStreams +
										') was supposed to be 1 (video) or 2 (audio+video)'
								);
							}

							streamHeaderSize = buf[5];
							state = 1;
						} else if (state == 1) {
							// Read Stream Header Remainder
							var buf = stream.Read(streamHeaderSize);
							if (buf == null) {
								return pump();
							}

							// Read BITMAPINFOHEADER structure
							var offsetWrapper = { offset: 0 };
							var bitmapHeaderSize = ReadUInt32LE(buf, offsetWrapper);
							offsetWrapper.offset -= 4; // Reverse the previous read so it will be included in the object.
							if (bitmapHeaderSize > 0) {
								bitmapHeader = new BITMAPINFOHEADER(ReadSubArray(buf, offsetWrapper, bitmapHeaderSize));
							}

							if (offsetWrapper.offset < streamHeaderSize) {
								// Audio stream was provided.
								// Assuming the remainder of the header is WAVEFORMATEX structure
								audioHeader = new WAVEFORMATEX(
									ReadSubArray(buf, offsetWrapper, streamHeaderSize - offsetWrapper.offset)
								);
							}

							state = 2;
						} else if (state == 2) {
							// Read Block Header Start
							var buf = stream.Read(5);
							if (buf == null) {
								return pump();
							}

							// First 4 bytes are supposed to be ASCII "Blue"
							if (buf[0] != 66 || buf[1] != 108 || buf[2] != 117 || buf[3] != 101) {
								return callStreamEnded(reader, 'block did not start with "Blue"');
							}

							blockType = buf[4];
							state = 3;
						} else if (state == 3) {
							// Read Block Header Remainder
							if (blockType == 0) {
								// Video
								var buf = stream.Read(18); // 2 + 4 + 8 + 4
								if (buf == null) {
									return pump();
								}
								var offsetWrapper = { offset: 0 };
								currentVideoFrame.pos = ReadUInt16(buf, offsetWrapper);
								currentVideoFrame.rawtime = ReadUInt32(buf, offsetWrapper); // Position of the frame relative to the start of the clip
								currentVideoFrame.time = currentVideoFrame.rawtime; // After below computation, this will be the playback clock timestamp at which to render the frame.
								currentVideoFrame.utc = ReadUInt64LE(buf, offsetWrapper);
								currentVideoFrame.size = ReadUInt32(buf, offsetWrapper);

								if (baseVideoFrameTime === -1) {
									baseVideoFrameTime = currentVideoFrame.time;
								}

								if (lastVideoFrameTime != -1) {
									// If time jumped backwards more than one billion milliseconds, assume the UINT32 overflowed to 0.
									if (lastVideoFrameTime - 1000000000 > currentVideoFrame.time) {
										baseVideoFrameTime -= UINT32_MAX;
									}
									// If time jumped forward more than one billion milliseconds, assume the UINT32 overflowed to UINT32_MAX.
									if (lastVideoFrameTime + 1000000000 < currentVideoFrame.time) {
										baseVideoFrameTime += UINT32_MAX;
									}
								}
								lastVideoFrameTime = currentVideoFrame.time;

								currentVideoFrame.time -= baseVideoFrameTime;
								currentVideoFrame.time = Math.abs(currentVideoFrame.time);

								if (currentVideoFrame.size > 10000000) {
									return callStreamEnded(
										reader,
										'Video frame size of ' + currentVideoFrame.size + ' was rejected.'
									);
								}

								state = 4;
							} else if (blockType == 1) {
								// Audio
								var buf = stream.Read(4);
								if (buf == null) {
									return pump();
								}

								currentAudioFrame.size = ReadInt32(buf, { offset: 0 });
								if (currentAudioFrame.size > 2000000) {
									return callStreamEnded(
										reader,
										'Audio frame size of ' + currentAudioFrame.size + ' was rejected.'
									);
								}

								state = 4;
							} else if (blockType == 2) {
								// Status
								var buf = stream.Read(1);
								if (buf == null) {
									return pump();
								}

								statusBlockSize = buf[0];

								if (statusBlockSize < 6) {
									return callStreamEnded(
										reader,
										'Status block size was invalid (' + statusBlockSize + ')!'
									);
								}

								state = 4;
							} else if (blockType == 4) {
								callStreamEnded(reader);
								return;
							} else {
								return callStreamEnded(
									reader,
									'Unknown block type ' + blockType + ' at state ' + state
								);
							}
						} else if (state == 4) {
							// Read AV frame data
							if (blockType == 0) {
								// Video
								var buf = stream.Read(currentVideoFrame.size);
								if (buf == null) {
									return pump();
								}

								callFrameCallback(new BIVideoFrame(buf, currentVideoFrame), availableStreams);

								state = 2;
							} else if (blockType == 1) {
								// Audio
								var buf = stream.Read(currentAudioFrame.size);
								if (buf == null) {
									return pump();
								}

								callFrameCallback(new BIAudioFrame(buf, audioHeader), availableStreams);

								state = 2;
							} else if (blockType == 2) {
								// Status
								var buf = stream.Read(statusBlockSize - 6); // We already read the first 6 bytes ['B', 'L', 'U', 'E', 2, statusBlockSize]
								if (buf == null) {
									return pump();
								}

								state = 2;
							} else {
								return callStreamEnded(
									reader,
									'Unknown block type ' + blockType + ' at state ' + state
								);
							}
						}
					}
				} catch (e) {
					// Do nothing.
				}
			})
			['catch'](function (e) {
				try {
					callStreamEnded(reader);
				} catch (e) {
					// Do nothing.
				}
			});
	}

	// Start the pump
	pump();
}
